import React, { useEffect, useState } from 'react'
import './user-view.styles.scss'
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { UseCloudAdminFunction } from '../../../utils/firebase.utils';
import { ModalAlert } from '../../modal/modal.component';
import MyEvalsList from '../../HOME/home-content/my-evals-list.component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';

const UserView = () => {
  
  const userProfile = useSelector(state => state.userData.userProfile);
  const dbData = useSelector(state => state.userData.dbData);
  const { cstKey } = useParams();
  const [ userData, setUserData ] = useState(null);
  const [ evalList, setEvalList ] = useState(null);
  const [ alertMessage, setAlertMessage ] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (!dbData || !cstKey) return;
    if (!dbData.Admin) {
      navigate('/');
    }
    getUserData(cstKey);
  }, [dbData, cstKey]);

  async function getUserData(cstKey) {
    const res = await UseCloudAdminFunction(
      'getUserRecord',
      {
        'cstKey': cstKey
      }
    )
    if (res.error) {
      setAlertMessage('Error retrieving user data. Please try again.');
      return;
    }
    const latestRel = res
    .filter(i => !i.ixo_end_date)
    .sort((a, b) => new Date(a.ixo_start_date) < new Date(b.ixo_start_date) ? 1 : -1 );
    setUserData(latestRel[0]);

  }

  return (
    <div className='user-view-container'>
      <button 
        className='g-button small-btn' 
        onClick={() => navigate(-1)}>
        <FontAwesomeIcon icon={faArrowLeft} /> Back
      </button>
      <div className="g-space-1"></div>
      <div className='user-info'>
        {userData && (
          <div className='info-box'>
            <h4>{userData.ind_first_name} {userData.ind_last_name}</h4>
            <p>
              <a href={`https://eweb.ilprincipals.org/iweb/forms/DynamicProfile.aspx?FormKey=b772881d-d704-40f3-92b6-09b13a50fcc9&Key=${userData.ind_cst_key}`} target='_blank' rel='noreferrer'>
                {userData.cst_recno}
              </a>
            </p>
            <p>{userData.cst_eml_address_dn}</p>
            <p>{userData.cst_ixo_title_dn}</p>
            <p>{userData.cst_org_name_dn}</p>
            {
              (userData.cst_org_name_dn !== userData.v01_ultimate_org_name) &&
              <p>{userData.v01_ultimate_org_name}</p>
            }
            <p className='meta'>CST Key: {userData.ind_cst_key}</p>
          </div>
        )}
        <div className="g-space-2"></div>
        {
          (userData) &&
          <MyEvalsList 
            setPlatform={() => {}}
            adminData={userData} />
        }
      </div>
      <ModalAlert
        show={alertMessage}
        cancel={() => setAlertMessage(null)}
        message={alertMessage} />
    </div>
  )
}

export default UserView